import { render, staticRenderFns } from "./EditarVisitaDialog.vue?vue&type=template&id=622d5a09&"
import script from "./EditarVisitaDialog.vue?vue&type=script&lang=js&"
export * from "./EditarVisitaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditarVisitaDialog.vue"
export default component.exports